import { useCallback, useEffect, useState } from "react";
import { EVENTO_PENDIENTES } from "../utils/almacenLocal";
import {
  EVENTO_SINCRONIZACION,
  estaSincronizando,
  listarPendientesUsuario,
} from "../utils/colaSincronizacion";

// Estado de la conexión y de la cola de registros sin enviar.
const useConexion = () => {
  const [enLinea, setEnLinea] = useState(navigator.onLine);
  const [pendientes, setPendientes] = useState([]);
  const [sincronizando, setSincronizando] = useState(estaSincronizando());

  const recargarPendientes = useCallback(() => {
    listarPendientesUsuario()
      .then(setPendientes)
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    const alConectar = () => setEnLinea(true);
    const alDesconectar = () => setEnLinea(false);
    const alSincronizar = (evento) => setSincronizando(evento.detail.sincronizando);

    window.addEventListener("online", alConectar);
    window.addEventListener("offline", alDesconectar);
    window.addEventListener(EVENTO_PENDIENTES, recargarPendientes);
    window.addEventListener(EVENTO_SINCRONIZACION, alSincronizar);
    recargarPendientes();

    return () => {
      window.removeEventListener("online", alConectar);
      window.removeEventListener("offline", alDesconectar);
      window.removeEventListener(EVENTO_PENDIENTES, recargarPendientes);
      window.removeEventListener(EVENTO_SINCRONIZACION, alSincronizar);
    };
  }, [recargarPendientes]);

  return {
    enLinea,
    sincronizando,
    porEnviar: pendientes.filter((p) => p.estado !== "error"),
    conError: pendientes.filter((p) => p.estado === "error"),
  };
};

export default useConexion;
